'use strict';

const { cropImage } = require('../../../../pmtPlacesApp/subscriptions/imageSubscriptions.js');

function ConflictResolver(
	$compile,
	$scope,
	$location,
	$timeout,
	$http,
	auth,
	pmtSiteInfoService,
	pmtElmService,
	pmtSiteService,
	pmtEnabledNetworksService
) {
	let $ctrl = this;
	$ctrl.args = null;
	$ctrl.currentLocationId = null;
	$ctrl.isEditingField = null;
	$ctrl.place = null;
	$ctrl.openEdit = null;
	$ctrl.openServiceArea = null;

	pmtSiteInfoService.subscribeToWork(function (msg) {
		if (msg && msg.work) {
			$timeout(function () {
				pmtElmService.sendData(
					'Conflicts.Resolver.Main',
					msg.work.success
						? 'in_Conflicts_Resolver_Main_workSucceeded'
						: 'in_Conflicts_Resolver_Main_workFailed',
					msg.work.id
				);
			});
		}
	});

	$ctrl.onClose = function () {
		$timeout(function () {
			pmtElmService.sendData('Conflicts.Resolver.Main', 'in_Conflicts_Resolver_Main_editorClosed', {
				field: $ctrl.isEditingField,
				locationId: $ctrl.place._id
			});
			$ctrl.isEditingField = null;
		});
	};

	$ctrl.onUpdate = function (workId, updatedLocation) {
		$timeout(function () {
			pmtElmService.sendData(
				'Conflicts.Resolver.Main',
				'in_Conflicts_Resolver_Main_editorUpdated',
				{
					field: $ctrl.isEditingField,
					locationId: $ctrl.place._id,
					workId: workId,
					location: updatedLocation
				}
			);
		});
	};

	function openEdit(field, data, placeData) {
		$timeout(function () {
			$ctrl.place = placeData ? placeData : data.location;

			$ctrl.openEdit = null;
			$ctrl.openServiceArea = null;

			if (field === 'serviceAreas') {
				$ctrl.openServiceArea = 'serviceAreas';
			} else {
				$ctrl.openEdit = field;
			}
		});
	}

	$ctrl.subscriptions = [
		{
			id: 'setCurrentIdCommand',
			f: function (locationId) {
				$timeout($location.search('id', locationId));
				$ctrl.currentLocationId = locationId;
			}
		},
		cropImage(
			pmtElmService,
			{
				id: 'cropImage',
				elmModule: 'Conflicts.Resolver.Main',
				capturedPort: 'in_Conflicts_Resolver_Main_onImageCaptured'
			},
			document
		),
		{
			id: 'editCommand',
			f: function (data) {
				$ctrl.isEditingField = data.field;
				switch (data.field) {
					case 'name':
						openEdit('name', data);
						break;

					case 'customNameFacebook':
						openEdit('facebookCustomName', data);
						break;

					case 'customNameGoogle':
						openEdit('googleCustomName', data);
						break;

					case 'storeId':
						$http
							.get('api/' + encodeURI($ctrl.site) + '/place/' + data.location._id)
							.then(function (place) {
								openEdit('storeId', data, place.data);
							});
						break;

					case 'locationDescriptor':
						openEdit('locationDescriptor', data);
						break;

					case 'location':
						$http
							.get('api/' + encodeURI($ctrl.site) + '/place/' + data.location._id)
							.then(function (place) {
								place.data.location = data.location.location;
								openEdit('location', data, place.data);
							});
						break;

					case 'address':
						$http
							.get('api/' + encodeURI($ctrl.site) + '/place/' + data.location._id)
							.then(function (place) {
								openEdit('address', data, place.data);
							});
						break;

					case 'phone':
						openEdit('phone', data);
						break;

					case 'homepage':
						$http
							.get('api/' + encodeURI($ctrl.site) + '/place/' + data.location._id)
							.then(function (place) {
								openEdit('homepage', data, place.data);
							});
						break;

					case 'email':
						openEdit('email', data);
						break;

					case 'shortDescription':
						openEdit('shortDescription', data);
						break;

					case 'longDescription':
						openEdit('longDescription', data);
						break;

					case 'hours':
						$http
							.get('api/' + encodeURI($ctrl.site) + '/place/' + data.location._id)
							.then(function (place) {
								openEdit('hours', data, place.data);
							});
						break;

					case 'openingDate':
						openEdit('openingDate', data);
						break;

					case 'specialHours':
						$http
							.get('api/' + encodeURI($ctrl.site) + '/place/' + data.location._id)
							.then(function (place) {
								openEdit('specialHours', data, place.data);
							});
						break;

					case 'networkAttributes':
						openEdit('networkAttributes', data);
						break;

					case 'permanentlyClosed':
						openEdit('permanentlyClosed', data);
						break;

					case 'temporarilyClosedUntil':
						openEdit('temporarilyClosedUntil', data);
						break;

					case 'networkCategoriesGoogle':
						$http
							.get('api/' + encodeURI($ctrl.site) + '/place/' + data.location._id)
							.then(function (place) {
								openEdit('googlenetworkcategories', data, place.data);
							});
						break;
					case 'networkCategoriesFacebook':
						$http
							.get('api/' + encodeURI($ctrl.site) + '/place/' + data.location._id)
							.then(function (place) {
								openEdit('facebooknetworkcategories', data, place.data);
							});
						break;

					case 'networkCategoriesBing':
						$http
							.get('api/' + encodeURI($ctrl.site) + '/place/' + data.location._id)
							.then(function (place) {
								openEdit('bingnetworkcategories', data, place.data);
							});
						break;

					case 'serviceAreas':
						$http
							.get('api/' + encodeURI($ctrl.site) + '/place/' + data.location._id)
							.then(function (place) {
								openEdit('serviceAreas', data, place.data);
							});
						break;

					default:
						$ctrl.isEditingField = null;
						break;
				}
			}
		}
	];

	function parseFields(x) {
		if (x && x.split) {
			return x.split(',');
		} else if (x) {
			return ['' + x];
		} else {
			return [];
		}
	}

	pmtSiteService.getSite().then(function (site) {
		$ctrl.site = site.name;

		const account = {
			name: site.name,
			displayName: site.displayName,
			features: {
				allowFacebookCustomName:
					(site.places.feature.allowFacebookCustomName &&
						site.places.feature.allowFacebookCustomName.enabled) === true,
				allowGoogleCustomName:
					(site.places.feature.allowGoogleCustomName &&
						site.places.feature.allowGoogleCustomName.enabled) === true,
				allowCustomStoreNames:
					(site.places.feature.allowCustomStoreNames &&
						site.places.feature.allowCustomStoreNames.enabled) === true
			},
			networks: pmtEnabledNetworksService.enabledNetworks(site)
		};

		const fields = parseFields($location.search().fields);
		if (!fields.length) {
			$location.search().id = $location.path().split('/')[3]
				? $location.path().split('/')[3]
				: $location.search().id;
		}
		const demoMode = localStorage.getItem('isDemo') === 'true';
		$ctrl.args = {
			account: account,
			editableFields: fields.filter(function (x) {
				switch (x) {
					case 'name':
						return (
							account.features.allowCustomStoreNames ||
							(auth.user.localAccess.roles.has('customersuccess') && !demoMode)
						);
					default:
						return true;
				}
			}),
			fields: fields,
			locationId: $location.search().id || null,
			isAccountConflictsResolver: !$location.path().split('/').includes($location.search().id)
		};
	});
}

ConflictResolver.$inject = [
	'$compile',
	'$scope',
	'$location',
	'$timeout',
	'$http',
	'auth',
	'pmtSiteInfoService',
	'pmtElmService',
	'pmtSiteService',
	'pmtEnabledNetworksService'
];

angular.module('pmtPlacesApp.directives').component('pmtConflictResolver', {
	controller: ConflictResolver,
	templateUrl: 'components/conflicts/pmtConflictResolver.html'
});
